import { render, staticRenderFns } from "./UsersLogTable.vue?vue&type=template&id=2bba10f6&"
import script from "./UsersLogTable.vue?vue&type=script&lang=js&"
export * from "./UsersLogTable.vue?vue&type=script&lang=js&"
import style0 from "./UsersLogTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports